'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Sidebar from 'ContentEditorUI/components/sidebar/Sidebar';
import AppReadyContainer from 'ContentEditorUI/containers/AppReadyContainer';
import { getActiveSidebarPanel, getIsSidebarExpanded } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { APPLY_CHANGES_PORTAL_SELECTOR } from 'ContentEditorUI/lib/sidebar/constants';
import { getIsReadOnlyMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  activePanel: getActiveSidebarPanel(state),
  isOpen: getIsSidebarExpanded(state),
  isReadOnlyMode: getIsReadOnlyMode(state)
});
class SidebarContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      applyChangesButtonContainer: document.getElementById(APPLY_CHANGES_PORTAL_SELECTOR)
    };
  }
  componentDidMount() {
    if (!this.state.applyChangesButtonContainer) {
      const applyChangesButtonContainer = document.createElement('div');
      applyChangesButtonContainer.setAttribute('id', APPLY_CHANGES_PORTAL_SELECTOR);
      document.body.appendChild(applyChangesButtonContainer);
      this.setState({
        applyChangesButtonContainer
      });
    }
  }
  render() {
    const {
      activePanel,
      children,
      isOpen,
      isReadOnlyMode,
      headerLabel
    } = this.props;
    return /*#__PURE__*/_jsx(AppReadyContainer, {
      children: /*#__PURE__*/_jsx(Sidebar, {
        isOpen: isOpen,
        activePanel: activePanel,
        isReadOnlyMode: isReadOnlyMode,
        headerLabel: headerLabel,
        children: children
      })
    });
  }
}
SidebarContainer.propTypes = {
  children: PropTypes.node.isRequired,
  activePanel: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isReadOnlyMode: PropTypes.bool.isRequired,
  headerLabel: PropTypes.node
};
export default connect(mapStateToProps)(SidebarContainer);